module.exports = __webpack_public_path__ + "static/media/marketplace-product-img-6.d60bf45e.svg";